import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'filterClients'
})
export class FilterClientsPipe implements PipeTransform {

  transform(value: any, arg: any): any {
    if (!value) return [];
    if (!arg || arg.trim() === '') return value;

    const resultPosts = [];
    const searchTerm = this.normalizeText(arg);

    for (const post of value) {
      // Normalizamos el nombre de la empresa
      const companyName = post.nombre ? this.normalizeText(post.nombre) : '';
      
      // Normalizamos la propiedad del encargado (ajusta 'encargado' o 'contacto' según se llame en tu objeto)
      const managerName = post.nombreCliente ? this.normalizeText(post.nombreCliente) : '';
      const contactName = post.contacto ? this.normalizeText(post.contacto) : '';

      // Si coincide en el nombre de la empresa O en el del encargado
      if (
        companyName.indexOf(searchTerm) > -1 || 
        managerName.indexOf(searchTerm) > -1 ||
        contactName.indexOf(searchTerm) > -1
      ) {
        resultPosts.push(post);
      }
    }

    return resultPosts;
  }

  // Función para quitar acentos y convertir a minúsculas
  private normalizeText(text: string): string {
    return text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

}